// extracted by mini-css-extract-plugin
export default {"dropdown":"winnerList_dropdown__sfLYW","DropdownMenu":"winnerList_DropdownMenu__m-+ql","dropIcn":"winnerList_dropIcn__j4L0J"};